export const STATUSES = {
  nuova: { label: "Nuova", cls: "bg-[#E8EEF8] text-[#0F2D5E] border-[#A9BEE3]" },
  in_verifica: { label: "In verifica", cls: "bg-[#FFF8E1] text-[#8A6100] border-[#FFE082]" },
  inoltrata: { label: "Inoltrata", cls: "bg-[#E1F5FE] text-[#0277BD] border-[#81D4FA]" },
  conclusa: { label: "Conclusa", cls: "bg-[#DCEFDD] text-[#1E6B24] border-[#A5D6A7]" },
  rifiutata: { label: "Rifiutata", cls: "bg-[#FFEBEE] text-[#C62828] border-[#EF9A9A]" },
};

export const fmtDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d.length === 10 ? `${d}T00:00:00` : d);
  return dt.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const ageDays = (d) => Math.floor((Date.now() - new Date(`${d}T00:00:00`).getTime()) / 86400000);

export const CONTACT_EMAIL = "info@iosegnalo.net";

export const homeFor = (u) => {
  if (u.role === "admin") return "/admin";
  if (u.role === "company") return "/azienda";
  return u.profile_completed === false ? "/completa-profilo" : "/dashboard";
};
